import { AxiosResponse } from 'axios';
import { ApiRepository, RequestParameters } from './base_repository';
import { API_BASE, LOCAL_STORAGE_TOKEN_KEY } from '../../config/constants';
import { toast } from 'react-toastify';

function handleAuthError() {
  setTimeout(() => {
    localStorage.removeItem(LOCAL_STORAGE_TOKEN_KEY);
  }, 2000);
  toast.error(
    'Oops! your session has expired. please logout and login again.',
    {
      toastId: 'session-expired',
    },
  );
}
class AuthenticatedRequestFailedError extends Error {
  constructor() {
    super('Authenticated request failed');
    this.name = 'AuthenticatedRequestFailedError';
    // TODO LOGOUT
  }
}

export abstract class AuthenticatedApiRepository extends ApiRepository {
  AuthAPIPrefix = 'auth_api';
  constructor(axiosInstance: any) {
    super(axiosInstance);
  }

  private async getAuthToken(): Promise<string | null> {
    const authToken = localStorage.getItem(LOCAL_STORAGE_TOKEN_KEY);
    if (authToken === null) {
      return null; // TODO LOGOUT
    } else {
      return authToken;
    }
  }

  public async sendRequest<T>(
    method: string,
    path: string,
    options: RequestParameters = {
      baseApiUrl: API_BASE,
      mustEndWithSlash: true,
      data: undefined,
      additionalHeaders: undefined,
      timeout: 30000,
    },
  ): Promise<AxiosResponse<any>> {
    const splitPath = path.split('?');
    let updatedPath = splitPath[0];
    if (!updatedPath.endsWith('/') && options.mustEndWithSlash) {
      updatedPath += '/';
    }

    if (splitPath.length > 1) {
      updatedPath += '?' + splitPath[1];
    }

    const authToken = await this.getAuthToken();
    if (!authToken) {
      handleAuthError();
    }

    options.additionalHeaders ??= {};
    options.additionalHeaders['authorization'] = `Bearer ${authToken}`;

    try {
      const response = await this.axiosInstance.request<T>({
        url: `${options.baseApiUrl}${updatedPath}`,
        method: method,
        headers: options.additionalHeaders,
        params: options.queryParameters,
        data: options.data,
        timeout: options.timeout,
      });
      if (response.status === 401) {
        toast.error('Authentication failed');
        throw new AuthenticatedRequestFailedError();
      }
      return response;
    } catch (error) {
      // this.handleConnectionError(error);
      // TODO handle connection error
      if ((error as any)?.response?.status === 401) {
        handleAuthError();
      }
      return Promise.reject(error); // Add this line to return a rejected promise
    }
  }
}
